import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAuth } from "../../contexts/authContext";

export const PublicRoute = ({
  children,
  restricted,
  ...rest
}: RouteProps & { restricted: boolean }) => {
  const auth = useAuth();
  return (
    <Route
      {...rest}
      render={() => (
        <>
          {auth.isAuthenticated && restricted ? (
            <Redirect to={{ pathname: "/profile" }} />
          ) : (
            children
          )}
        </>
      )}
    />
  );
};
